<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Type of Report
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-select v-model="form.rptType" :items="reportTypeList" :label="labels.rptType" item-text="label" item-value="value" />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Date Range
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <cal-picker v-model="form.fromDate" :label="labels.fromDate" v-validate="fromDateValidation(form.toDate)" :data-vv-as="labels.fromDate" data-vv-name="fromDate" :error-messages="errors.collect('fromDate')"></cal-picker>
                      </v-flex>
                      <v-flex xs6>
                        <cal-picker v-model="form.toDate" :label="labels.toDate" v-validate="toDateValidation(form.fromDate)" :data-vv-as="labels.toDate" data-vv-name="toDate" :error-messages="errors.collect('toDate')" :min="form.fromDate"></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel3" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Selection Criteria
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm12>
                        <v-text-field v-model="form.sector" :label="labels.sector" :error-messages="errors.collect('form.sector')" :data-vv-as="labels.sector" v-validate="'required'"
                          data-vv-name="form.sector" append-icon="mdi-magnify" @click:append="showSectorHelpList=true" @click="showSectorHelpList=true" readonly/>
                      </v-flex>
                      <v-flex xs12 sm12>
                        <v-text-field v-model="form.division" :label="labels.division" :error-messages="errors.collect('form.division')" :data-vv-as="labels.division" v-validate="'required'"
                          data-vv-name="form.division" append-icon="mdi-magnify" @click:append="showDivisionHelpList=true" @click="showDivisionHelpList=true" readonly/>
                      </v-flex>
                      <v-flex xs12 sm12>
                        <v-text-field v-model="form.team" :label="labels.team" :error-messages="errors.collect('form.team')" :data-vv-as="labels.team" v-validate="'required'"
                          data-vv-name="form.team" append-icon="mdi-magnify" @click:append="showTeamHelpList=true" @click="showTeamHelpList=true" readonly/>
                      </v-flex>
                      <v-flex xs12 sm12 v-if="form.rptType == 'detail'">
                        <v-text-field v-model="form.arm" :label="labels.arm" :error-messages="errors.collect('form.arm')" :data-vv-as="labels.arm" v-validate="'required'"
                          data-vv-name="form.arm" append-icon="mdi-magnify" @click:append="showARMHelpList=true" @click="showARMHelpList=true" readonly/>
                      </v-flex>
                      <v-flex xs12 sm12 v-else>
                        <v-text-field v-model="form.execIC" :label="labels.execIC" :error-messages="errors.collect('form.execIC')" :data-vv-as="labels.execIC" v-validate="'required'"
                          data-vv-name="form.execIC" append-icon="mdi-magnify" @click:append="showExecICHelpList=true" @click="showExecICHelpList=true" readonly/>
                      </v-flex>
                      <v-flex xs4 class="pt-3" v-if="form.rptType == 'detail'">
                        <v-checkbox
                          dense
                          v-model="form.printSummary"
                          :label="labels.printSummary"
                          :error-messages="errors.collect('printSummary')"
                          data-vv-name="printSummary"
                          :data-vv-as="labels.printSummary"
                          hide-details
                          ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12>
          <v-checkbox
            dense
            v-model="form.rptParam"
            :label="labels.rptParam"
            :error-messages="errors.collect('rptParam')"
            data-vv-name="rptParam"
            :data-vv-as="labels.rptParam"
            hide-details
            ></v-checkbox>
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{format.label}}</span>
              <v-icon :color="format.color">{{format.icon}}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="showSectorHelpList" width="900px" persistent>
      <sector-help-list :sector="form.sector" @close="doClose" @doAssign="doAssignSector($event)" />
    </v-dialog>
    <v-dialog v-model="showDivisionHelpList" width="900px" persistent>
      <division-help-list :division="form.division" @close="doClose" @doAssign="doAssignDivision($event)" />
    </v-dialog>
    <v-dialog v-model="showTeamHelpList" width="900px" persistent>
      <team-help-list :team="form.team" @close="doClose" @doAssign="doAssignTeam($event)" />
    </v-dialog>
    <v-dialog v-model="showARMHelpList" width="900px" persistent>
      <ARM-help-list :arm="form.arm" @close="doClose" @doAssign="doAssignARM($event)" />
    </v-dialog>
    <v-dialog v-model="showExecICHelpList" width="900px" persistent>
      <multi-exec-in-charge-help-list :execic="form.execIC" @close="doClose" @doAssign="doAssignExecIC($event)"/>
    </v-dialog>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import SectorHelpList from '@/components/core/common/dialog/SectorHelpList.vue'
import DivisionHelpList from '@/components/core/common/dialog/DivisionHelpList.vue'
import TeamHelpList from '@/components/core/common/dialog/TeamHelpList.vue'
import ARMHelpList from '@/components/core/common/dialog/ARMHelpList.vue'
import MultiExecInChargeHelpList from '@/components/core/common/dialog/MultiExecInChargeHelpList'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import { checkDateRangeFrom, checkDateRangeTo } from '@/directives/common'
export default {
  mixins: [
    MessageMixin
  ],
  components: {
    SectorHelpList,
    DivisionHelpList,
    TeamHelpList,
    ARMHelpList,
    MultiExecInChargeHelpList
  },
  data() {
    return {
      menu: {},
      showSectorHelpList: false,
      showDivisionHelpList: false,
      showTeamHelpList: false,
      showARMHelpList: false,
      submitting: false,
      showExecICHelpList: false,
      form: {
        rptType: 'detail',
        fromDate: '',
        toDate: '',
        sector: 'All',
        division: 'All',
        arm: 'All',
        team: 'All',
        execIC: 'All',
        rptParam: true,
        format: 'PDF',
        printSummary: false
      },
      labels: {
        fromDate: 'Transaction Date From',
        toDate: 'Transaction Date To',
        sector: 'Sector',
        division: 'Division',
        team: 'Team',
        arm: 'ARM',
        execIC: 'Executive-in-Charge',
        rptType: 'Report Type',
        rptParam: 'Print Runtime Parameters',
        export: 'EXPORT TO',
        printSummary: 'Print Summary'
      },
      driList: [
        { label: 'D - Direct', value: 'D' },
        { label: 'R - Reinsurance', value: 'R' },
        { label: 'B - Both', value: 'B' }
      ],
      reportTypeList: [
        { label: 'Bonus Incentive Scheme – Details', value: 'detail' },
        { label: 'Bonus Incentive Scheme by Executive In-charge', value: 'execIC' }
      ],
      columns: [
        { label: 'Sector', value: 'sector' },
        { label: 'Division', value: 'division' },
        { label: 'Team', value: 'team' },
        { label: 'ARM', value: 'arm' },
        { label: 'Exec-in-Charge', value: 'execIC' }
      ],
      headers: [
        { label: 'Sub Total', value: 'subTotal' },
        { label: 'Page Break', value: 'pageBreak' }
      ],
      sortedListContainer: {
        sortedList: [],
        cDescList: []
      },
      supportedFormat: [],
      panel1: [0],
      panel2: [0],
      panel3: [0]
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      if (this.$store.state.reports.uwReports.init !== 1) {
        await this.$store.dispatch('uwReportsInit')
      }
      const apiURI = this.rptMenu.initBoIncScheme
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result.data
            if (data) {
              this.supportedFormat = data.format
              this.menu = extractMenu(result.data._links)
            }
          }
        } catch (err) {
          throw err
        }
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.exportDetail
      if (apiURI) {
        this.submitting = true
        try {
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doClose() {
      this.showSectorHelpList = false
      this.showDivisionHelpList = false
      this.showTeamHelpList = false
      this.showARMHelpList = false
      this.showExecICHelpList = false
    },
    async doAssignSector(obj) {
      this.form.sector = []
      this.form.sector = obj.finalSelectedItems.toString()
    },
    async doAssignDivision(obj) {
      this.form.division = []
      this.form.division = obj.finalSelectedItems.toString()
    },
    async doAssignTeam(obj) {
      this.form.team = []
      this.form.team = obj.finalSelectedItems.toString()
    },
    async doAssignARM(obj) {
      this.form.arm = []
      this.form.arm = obj.finalSelectedItems.toString()
    },
    async doAssignExecIC(Obj) {
      this.form.execIC = Obj.finalSelectedItems.toString()
    },
    fromDateValidation(toDate1) {
      if (toDate1) {
        return 'required|checkDateRangeFrom:' + toDate1
      } else {
        return 'required|checkDateRangeFrom'
      }
    },
    toDateValidation(fromDate1) {
      if (fromDate1) {
        return 'required|checkDateRangeTo:' + fromDate1
      } else {
        return 'required|checkDateRangeTo'
      }
    }
  },
  created() {
    this.$validator.extend('checkDateRangeFrom', checkDateRangeFrom)
    this.$validator.extend('checkDateRangeTo', checkDateRangeTo)
  }
}
</script>
